import { string } from 'prop-types';
import React, { Fragment } from 'react';
import Head from 'next/head';
import styles from './styles';

function AmpOutbrain({ canonical, widgetIds }) {
  if (!widgetIds) {
    return null;
  }
  return (
    <Fragment>
      <Head>
        <script
          async
          key="amp-ad"
          custom-element="amp-ad"
          src="https://cdn.ampproject.org/v0/amp-ad-0.1.js"
        />
      </Head>
      <div className="AmpOutbrain">
        <amp-embed
          width="100"
          height="100"
          type="outbrain"
          layout="responsive"
          data-widgetIds={widgetIds}
          data-htmlURL={canonical}
        />
      </div>
      <style jsx>{styles}</style>
    </Fragment>
  );
}

AmpOutbrain.defaultProps = {
  widgetIds: ''
};

AmpOutbrain.propTypes = {
  canonical: string.isRequired,
  widgetIds: string
};

export default AmpOutbrain;
